import { createContext, useContext, type ReactNode } from "react";
import { Dialog } from "../../components";
export const PrivateRevealContext = createContext<() => void>(() => {});
export function PrivateTrigger({
  children = "Open your card",
}: {
  children?: ReactNode;
}) {
  const reveal = useContext(PrivateRevealContext);
  return (
    <button
      type="button"
      className="primary accent full play-private-trigger"
      data-tour="private-trigger"
      onClick={reveal}
    >
      {children}
    </button>
  );
}
export function PrivatePanel({
  children,
  onClose,
}: {
  children: ReactNode;
  onClose: () => void;
}) {
  return (
    <Dialog
      title="Your private card"
      onClose={onClose}
      coverSecrets={false}
      className="play-private-dialog"
    >
      <div className="play-private-content">{children}</div>
      <button className="secondary full" onClick={onClose}>
        Cover your card
      </button>
    </Dialog>
  );
}
